import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

import Image from 'components/Image';

export const SQUARE = 'square';
export const CIRCLE = 'circle';

const borderRadiusByShape = {
  [SQUARE]: '8px',
  [CIRCLE]: '50%'
};
function Avatar({ src, path, shape = SQUARE }) {
  return (
    <Button
      href={path}
      sx={theme => ({
        [theme.breakpoints.up('md')]: {
          pl: 0
        },
        zIndex: 1
      })}
    >
      <Paper
        data-testid="account-avatar"
        sx={theme => ({
          height: '180px',
          width: '180px',
          overflow: 'hidden',
          boxShadow: theme.constants.boxShadows.normal,
          borderRadius: borderRadiusByShape[shape]
        })}
      >
        <Image src={src} objectFit={'contain'} />
      </Paper>
    </Button>
  );
}

Avatar.propTypes = {
  src: PropTypes.string,
  path: PropTypes.string,
  shape: PropTypes.oneOf([SQUARE, CIRCLE])
};

export default Avatar;
